// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-container {
  border-radius: 7px !important;
}

.sticky_header {
  position: sticky;
  left: 0;
}

.sticky_row {
  position: sticky;
  bottom: 0;
  z-index: 4;
  margin: 0;
  padding: 0;
}

.sticky_row td {
  margin: 0 !important;
  padding: 7px !important;
}

.sticky_row input,
.sticky_row select {
  background-color: #f5f5f5;
  color: black;
  height: 35px;
  width: 100%;
}

.hide_scrollbar::-webkit-scrollbar,
.inv_list_container::-webkit-scrollbar,
.price_list_container::-webkit-scrollbar,
.group_list_container::-webkit-scrollbar,
.packages_table_container::-webkit-scrollbar,
.gp_pkg_list_container::-webkit-scrollbar,
.package_list_container::-webkit-scrollbar,
.package_list_container_mobile::-webkit-scrollbar,
.form_main_container::-webkit-scrollbar {
  display: none !important;
}

.form_main_container {
  max-height: 95vh;
  overflow: scroll;
  padding-bottom: 100px;
}

.table {
  table-layout: fixed;
  border-collapse: collapse;
  background-color: white;
  border-top-left-radius: 9px !important;
}

.table th,
.table td {
  border: 1px solid #ccc;
  white-space: nowrap;
  text-overflow: ellipsis;
  position: relative;
  vertical-align: middle;
}

#table_form_row td,
#table_form_row td,
#table_form_row td input,
#table_form_row td select {
  font-weight: bold !important;
  color: gray !important;
  background-color: rgb(252, 250, 250);
}

.list_wrapper {
  padding: 20px;
  font-size: 14px;
}

.list_wrapper .row:hover {
  background-color: #f8fafc;
}

.list_wrapper .row .col,
.list_wrapper .row .check_col {
  border-bottom: 1px solid #e7e8ea;
  background-color: transparent;
  color: gray;
}

.switch_btn_div {
  display: flex;
  justify-content: center;
  align-items: center;
}

/*List style for PC */
.table_main_list thead {
  position: sticky;
  top: -4px;
  z-index: 3;
  background-color: white;
  border-radius: 8px;
  overflow: hidden;
}

.table_main_list th:nth-child(1) {
  width: 70px;
  border-top: 7px solid #f5bf00;
  position: sticky;
  left: -12px;
  z-index: 4;
}

.table_main_list th:nth-child(2) {
  width: 250px;
  border-top: 7px solid #f5bf00;
  position: sticky;
  left: 58px;
  z-index: 4;
  cursor: pointer;
}

.table_main_list td:nth-child(1) {
  position: sticky;
  left: -12px;
  z-index: 2;
}

.table_main_list td:nth-child(1) .checkbox_btn[type=checkbox] {
  margin-top: -4px;
  margin-left: -20px;
  height: 18px;
  width: 18px;
}

.table_main_list td:nth-child(1) .checkbox_btn[type=checkbox]:checked {
  background-color: #f5bf00 !important;
}

.table_main_list #sticky_col0 {
  position: sticky;
  left: 58px;
  z-index: 2;
}

.table_main_list th:last-child {
  width: 60px;
}

.table_main_list th,
.table_main_list td {
  width: 120px;
  font-size: 12px;
  color: gray !important;
}

/* List style for Mobile */
.table_main_list_mobile thead {
  position: sticky;
  top: -4px;
  z-index: 3;
  background-color: white;
}

.table_main_list_mobile th:nth-child(1) {
  width: 70px;
  border-top: 7px solid #f5bf00;
  /* position: sticky;
    left: -2px; */
}

.table_main_list_mobile th:nth-child(2) {
  width: 250px;
  border-top: 7px solid #f5bf00;
  /* position: sticky;
    left: 67px; */
}

.table_main_list_mobile td:nth-child(1) {
  /* position: sticky;;
    left: -2px;
    z-index: 2; */
}

.table_main_list_mobile #sticky_col0 {
  /* position: sticky;
    left: 67px;
    z-index: 2; */
}

.table_main_list_mobile th:last-child,
.table_main_list_mobile td:last-child {
  width: 60px;
  position: sticky;
  background-color: rgb(245, 241, 241);
}

.table_main_list_mobile th,
.table_main_list_mobile td {
  width: 120px;
  font-size: 12px;
  color: gray !important;
}

/* Inventory Services List style for PC */
.inv_list_container thead {
  position: sticky;
  top: -4px;
  z-index: 3;
  background-color: white;
  border-radius: 8px;
  overflow: hidden;
}

.inv_list_container th:nth-child(1) {
  width: 60px;
  border-top: 7px solid #ff9669;
  position: sticky;
  left: -2px;
  z-index: 4;
}

.inv_list_container th:nth-child(2) {
  width: 250px !important;
  border-top: 7px solid #ff9669;
  position: sticky;
  left: 67px;
  z-index: 4;
}

.inv_list_container td:nth-child(1) {
  position: sticky;
  left: -2px;
  z-index: 2;
}

.inv_list_container td:nth-child(1) .checkbox_btn[type=checkbox] {
  margin-top: -4px;
  margin-left: -20px;
  height: 18px;
  width: 18px;
}

.inv_list_container td:nth-child(1) .checkbox_btn[type=checkbox]:checked {
  background-color: #f5bf00 !important;
}

.inv_list_container #sticky_col0 {
  left: 0px;
  z-index: 2;
  cursor: pointer;
}

.inv_list_container #sticky_col0:hover {
  color: #f5bf00 !important;
}

.inv_list_container th:last-child {
  width: 60px;
}

.inv_list_container th,
.inv_list_container td {
  width: 120px;
  font-size: 12px;
  color: gray !important;
}

/* Inventory Services List style for Mobile */
.inv_list_container_mobile thead {
  top: -4px;
  z-index: 3;
  background-color: white;
}

.inv_list_container_mobile th:nth-child(1) {
  width: 70px;
  border-top: 7px solid #f5bf00;
  /* position: sticky;
    left: -2px; */
}

.inv_list_container_mobile th:nth-child(2) {
  width: 250px;
  border-top: 7px solid #f5bf00;
  /* position: sticky;
    left: 67px; */
}

.inv_list_container_mobile td:nth-child(1) {
  /* position: sticky;;
    left: -2px;
    z-index: 2; */
}

.inv_list_container_mobile #sticky_col0 {
  /* position: sticky;
    left: 67px;
    z-index: 2; */
}

.inv_list_container_mobile #sticky_col0:hover {
  color: #f5bf00 !important;
}

.inv_list_container_mobile th:last-child,
.inv_list_container_mobile td:last-child {
  width: 60px;
  position: sticky;
  right: -2px;
  background-color: rgb(245, 241, 241);
}

.inv_list_container_mobile th,
.inv_list_container_mobile td {
  width: 120px;
  font-size: 12px;
  color: gray !important;
}

/* Pricing Form style for PC */
.pricing_form_container thead {
  position: sticky;
  top: -4px;
  z-index: 3;
  background-color: white;
}

.pricing_form_container th:nth-child(1) {
  width: 70px;
  border-top: 7px solid #f5bf00;
  position: sticky;
  left: -2px;
  z-index: 4;
}

.pricing_form_container th:nth-child(2) {
  width: 250px;
  border-top: 7px solid #f5bf00;
  position: sticky;
  left: 67px;
  z-index: 4;
}

.pricing_form_container td:nth-child(1) .checkbox_btn[type=checkbox] {
  margin-top: -4px;
  margin-left: -20px;
  height: 18px;
  width: 18px;
}

.pricing_form_container td:nth-child(1) .checkbox_btn[type=checkbox]:checked {
  background-color: #f5bf00 !important;
}

.pricing_form_container td:nth-child(1) {
  position: sticky;
  left: -2px;
  z-index: 2;
}

.pricing_form_container #sticky_col0 {
  position: sticky;
  left: 67px;
  z-index: 2;
}

.pricing_form_container th:last-child {
  width: 60px;
}

.pricing_form_container th,
.pricing_form_container td {
  width: 120px;
  font-size: 12px;
  color: gray !important;
}

/*  Pricing form style for Mobile */
.pricing_form_container_mobile thead {
  position: sticky;
  top: -4px;
  z-index: 3;
  background-color: white;
}

.pricing_form_container_mobile th:nth-child(1) {
  width: 70px;
  border-top: 7px solid #f5bf00;
  /* position: sticky;
    left: -2px; */
}

.pricing_form_container_mobile th:nth-child(2) {
  width: 250px;
  border-top: 7px solid #f5bf00;
  /* position: sticky;
    left: 67px; */
}

.pricing_form_container_mobile td:nth-child(1) {
  /* position: sticky;;
    left: -2px;
    z-index: 2; */
}

.pricing_form_container_mobile #sticky_col0 {
  /* position: sticky;
    left: 67px;
    z-index: 2; */
}

.pricing_form_container_mobile th:last-child,
.pricing_form_container_mobile td:last-child {
  width: 60px;
  position: sticky;
  right: -2px;
  background-color: rgb(245, 241, 241);
}

.pricing_form_container_mobile th,
.pricing_form_container_mobile td {
  width: 120px;
  font-size: 12px;
  color: gray !important;
}

/* Pricing list style for PC */
.pricing_list_container thead {
  position: sticky;
  top: -4px;
  z-index: 3;
  background-color: white;
}

.pricing_list_container th:nth-child(1) {
  width: 70px;
  /* border-top: 7px solid #f5bf00; */
  position: sticky;
  left: -2px;
  z-index: 4;
}

.pricing_list_container th:nth-child(2) {
  width: 250px;
  /* border-top: 7px solid #f5bf00; */
  position: sticky;
  left: 67px;
  z-index: 4;
}

.pricing_list_container td:nth-child(1) .checkbox_btn[type=checkbox] {
  margin-top: -4px;
  margin-left: -20px;
  height: 18px;
  width: 18px;
}

.pricing_list_container td:nth-child(1) .checkbox_btn[type=checkbox]:checked {
  background-color: #f5bf00 !important;
}

.pricing_list_container td:nth-child(1) {
  position: sticky;
  left: -2px;
  z-index: 2;
}

.pricing_list_container #sticky_col0 {
  position: sticky;
  left: 67px;
  z-index: 2;
}

.pricing_list_container th:last-child {
  width: 60px;
}

.pricing_list_container th,
.pricing_list_container td {
  width: 120px;
  font-size: 12px;
  color: gray !important;
}

/*  Pricing list style for Mobile */
.pricing_list_container_mobile thead {
  position: sticky;
  top: -4px;
  z-index: 3;
  background-color: white;
}

.pricing_list_container_mobile th:nth-child(1) {
  width: 70px;
  /* border-top: 7px solid #f5bf00; */
  /* position: sticky;
    left: -2px; */
}

.pricing_list_container_mobile th:nth-child(2) {
  width: 250px;
  /* border-top: 7px solid #f5bf00; */
  /* position: sticky;
    left: 67px; */
}

.pricing_list_container_mobile td:nth-child(1) {
  /* position: sticky;;
    left: -2px;
    z-index: 2; */
}

.pricing_list_container_mobile #sticky_col0 {
  /* position: sticky;
    left: 67px;
    z-index: 2; */
}

.pricing_list_container_mobile th:last-child,
.pricing_list_container_mobile td:last-child {
  width: 60px;
  position: sticky;
  right: -2px;
  background-color: rgb(245, 241, 241);
}

.pricing_list_container_mobile th,
.pricing_list_container_mobile td {
  width: 120px;
  font-size: 12px;
  color: gray !important;
}

/* Cost Form style for PC */
.cost_form_container thead {
  position: sticky;
  top: -4px;
  z-index: 3;
  background-color: white;
}

.cost_form_container th:nth-child(1) {
  width: 70px;
  border-top: 7px solid #f5bf00;
  position: sticky;
  left: -2px;
  z-index: 4;
}

.cost_form_container th:nth-child(2) {
  width: 250px;
  border-top: 7px solid #f5bf00;
  position: sticky;
  left: 67px;
  z-index: 4;
}

.cost_form_container td:nth-child(1) .checkbox_btn[type=checkbox] {
  margin-top: -4px;
  margin-left: -20px;
  height: 18px;
  width: 18px;
}

.cost_form_container td:nth-child(1) .checkbox_btn[type=checkbox]:checked {
  background-color: #f5bf00 !important;
}

.cost_form_container td:nth-child(1) {
  position: sticky;
  left: -2px;
  z-index: 2;
}

.cost_form_container #sticky_col0 {
  position: sticky;
  left: 67px;
  z-index: 2;
}

.cost_form_container th:last-child {
  width: 60px;
}

.cost_form_container th,
.cost_form_container td {
  width: 120px;
  font-size: 12px;
  color: gray !important;
}

/*  Cost form style for Mobile */
.cost_form_container_mobile thead {
  position: sticky;
  top: -4px;
  z-index: 3;
  background-color: white;
}

.cost_form_container_mobile th:nth-child(1) {
  width: 70px;
  border-top: 7px solid #f5bf00;
  /* position: sticky;
    left: -2px; */
}

.cost_form_container_mobile th:nth-child(2) {
  width: 250px;
  border-top: 7px solid #f5bf00;
  /* position: sticky;
    left: 67px; */
}

.cost_form_container_mobile td:nth-child(1) {
  /* position: sticky;;
    left: -2px;
    z-index: 2; */
}

.cost_form_container_mobile #sticky_col0 {
  /* position: sticky;
    left: 67px;
    z-index: 2; */
}

.cost_form_container_mobile th:last-child,
.cost_form_container_mobile td:last-child {
  width: 60px;
  position: sticky;
  right: -2px;
  background-color: rgb(245, 241, 241);
}

.cost_form_container_mobile th,
.cost_form_container_mobile td {
  width: 120px;
  font-size: 12px;
  color: gray !important;
}

/* Attribute Form style for PC */
.attribute_form_container thead {
  position: sticky;
  top: -4px;
  z-index: 3;
  background-color: white;
}

.attribute_form_container th:nth-child(1) {
  width: 70px;
  border-top: 7px solid #f5bf00;
  position: sticky;
  left: -2px;
  z-index: 4;
}

.attribute_form_container th:nth-child(2) {
  width: 250px;
  border-top: 7px solid #f5bf00;
  position: sticky;
  left: 67px;
  z-index: 4;
}

.attribute_form_container td:nth-child(1) .checkbox_btn[type=checkbox] {
  margin-top: -4px;
  margin-left: -20px;
  height: 18px;
  width: 18px;
}

.attribute_form_container td:nth-child(1) .checkbox_btn[type=checkbox]:checked {
  background-color: #f5bf00 !important;
}

.attribute_form_container td:nth-child(1) {
  position: sticky;
  left: -2px;
  z-index: 2;
}

.attribute_form_container #sticky_col0 {
  position: sticky;
  left: 67px;
  z-index: 2;
}

.attribute_form_container th:last-child {
  width: 60px;
}

.attribute_form_container th,
.attribute_form_container td {
  width: 120px;
  font-size: 12px;
  color: gray !important;
}

/*  Attribute form style for Mobile */
.attribute_form_container_mobile thead {
  position: sticky;
  top: -4px;
  z-index: 3;
  background-color: white;
}

.attribute_form_container_mobile th:nth-child(1) {
  width: 70px;
  border-top: 7px solid #f5bf00;
  /* position: sticky;
    left: -2px; */
}

.attribute_form_container_mobile th:nth-child(2) {
  width: 250px;
  border-top: 7px solid #f5bf00;
  /* position: sticky;
    left: 67px; */
}

.attribute_form_container_mobile td:nth-child(1) {
  /* position: sticky;;
    left: -2px;
    z-index: 2; */
}

.attribute_form_container_mobile #sticky_col0 {
  /* position: sticky;
    left: 67px;
    z-index: 2; */
}

.attribute_form_container_mobile th:last-child,
.attribute_form_container_mobile td:last-child {
  width: 60px;
  position: sticky;
  right: -2px;
  background-color: rgb(245, 241, 241);
}

.attribute_form_container_mobile th,
.attribute_form_container_mobile td {
  width: 120px;
  font-size: 12px;
  color: gray !important;
}

/* Package Form style for PC */
.package_list_container thead {
  position: sticky;
  top: -4px;
  z-index: 3;
  background-color: white;
}

.package_list_container th:nth-child(1) {
  width: 70px;
  position: sticky;
  left: -2px;
  z-index: 4;
}

.package_list_container th:nth-child(2) {
  width: 250px;
  position: sticky;
  left: 67px;
  z-index: 4;
}

.package_list_container td:nth-child(1) .checkbox_btn[type=checkbox] {
  margin-top: -4px;
  margin-left: -20px;
  height: 18px;
  width: 18px;
}

.package_list_container td:nth-child(1) .checkbox_btn[type=checkbox]:checked {
  background-color: #f5bf00 !important;
}

.package_list_container td:nth-child(1) {
  position: sticky;
  left: -2px;
  z-index: 2;
}

.package_list_container #sticky_col0 {
  position: sticky;
  left: 67px;
  z-index: 2;
}

.package_list_container th:last-child {
  width: 60px;
}

.package_list_container th,
.package_list_container td {
  width: 120px;
  font-size: 12px;
  color: gray !important;
}

/*  Package form style for Mobile */
.package_list_container_mobile thead {
  position: sticky;
  top: -4px;
  z-index: 3;
  background-color: white;
}

.package_list_container_mobile th:nth-child(1) {
  width: 70px;
  /* border-top: 7px solid #f5bf00; */
  /* position: sticky;
    left: -2px; */
}

.package_list_container_mobile th:nth-child(2) {
  width: 250px;
  /* border-top: 7px solid #f5bf00; */
  /* position: sticky;
    left: 67px; */
}

.package_list_container_mobile td:nth-child(1) {
  /* position: sticky;;
    left: -2px;
    z-index: 2; */
}

.package_list_container_mobile #sticky_col0 {
  /* position: sticky;
    left: 67px;
    z-index: 2; */
}

.package_list_container_mobile th:last-child,
.package_list_container_mobile td:last-child {
  width: 60px;
  position: sticky;
  right: -2px;
  background-color: rgb(245, 241, 241);
}

.package_list_container_mobile th,
.package_list_container_mobile td {
  width: 120px;
  font-size: 12px;
  color: gray !important;
}

/* Group Form style for PC */
.group_form_container thead {
  position: sticky;
  top: -4px;
  z-index: 3;
  background-color: white;
}

.group_form_container th:nth-child(1) {
  width: 35px;
  /* border-top: 7px solid #f5bf00; */
  position: sticky;
  left: -2px;
  z-index: 4;
}

.group_form_container th:nth-child(2) {
  width: 250px;
  /* border-top: 7px solid #f5bf00; */
  position: sticky;
  left: 67px;
  z-index: 4;
}

.group_form_container td:nth-child(1) {
  position: sticky;
  left: -2px;
  z-index: 2;
}

.group_form_container #sticky_col0 {
  position: sticky;
  left: 67px;
  z-index: 2;
}

.group_form_container th:last-child {
  width: 35px !important;
}

.group_form_container th,
.group_form_container td {
  width: 120px;
  font-size: 12px;
  color: gray !important;
}

/*  Cost form style for Mobile */
.group_form_container_mobile thead {
  position: sticky;
  top: -4px;
  z-index: 3;
  background-color: white;
}

.group_form_container_mobile th:nth-child(1) {
  width: 70px;
  /* border-top: 7px solid #f5bf00; */
  /* position: sticky;
    left: -2px; */
}

.group_form_container_mobile th:nth-child(2) {
  width: 250px;
  /* border-top: 7px solid #f5bf00; */
  /* position: sticky;
    left: 67px; */
}

.group_form_container_mobile td:nth-child(1) {
  /* position: sticky;;
    left: -2px;
    z-index: 2; */
}

.group_form_container_mobile #sticky_col0 {
  /* position: sticky;
    left: 67px;
    z-index: 2; */
}

.group_form_container_mobile th:last-child,
.group_form_container_mobile td:last-child {
  width: 60px;
  position: sticky;
  right: -2px;
  background-color: rgb(245, 241, 241);
}

.group_form_container_mobile th,
.group_form_container_mobile td {
  width: 120px;
  font-size: 12px;
  color: gray !important;
}

/* Create Service */
.create_service {
  height: 100vh;
  overflow-y: scroll;
  padding-bottom: 180px;
  width: 100%;
}

.detail_form input,
.detail_form select {
  border: none;
  font-size: 14px;
}

.detail_form input:focus,
.detail_form select:focus {
  box-shadow: none;
  outline: none;
  border: none;
}

.detail_form input,
.detail_form select {
  border: none;
  font-size: 14px;
}

.detail_form input:focus,
.detail_form select:focus {
  box-shadow: none;
  outline: none;
  border: none;
}

.create_form_row input {
  border-left: none;
  border-top: none;
  border-right: none;
  border-bottom: 2px solid white;
  border-radius: 0px;
  font-size: 14px;
  color: gray;
}

.create_form_row input:focus {
  box-shadow: none;
  font-size: 14px;
  border-bottom: 2px solid #f5bf00;
}

.create_form_row .input_wrapper input,
.create_form_row .input_wrapper textarea {
  border-left: none;
  border-top: none;
  border-right: none;
  border-bottom: 2px solid white !important;
  border-radius: 0px;
  font-size: 14px;
  color: gray;
}

.create_form_row .input_wrapper input:focus,
.create_form_row .input_wrapper textarea:focus {
  border-bottom: 2px solid #f5bf00 !important;
}

.add-btn {
  margin-left: 10px;
  border-radius: 20px;
  background-color: transparent;
}

.addcol_btn_th {
  text-align: center;
  width: 40 !important;
}

.delete-btn {
  padding: 2px 5px;
  margin-left: 5px;
  background-color: #f44336;
  color: #fff;
  border: none;
  cursor: pointer;
}

.add-row-btn {
  margin-top: 10px;
}

.delete-btn:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

td input,
td select {
  background-color: transparent;
  border: none;
  width: 100%;
}

.tbl_footer_main {
  border-radius: 8px;
  opacity: 1;
  padding: 0;
}

.small_col {
  width: 70px !important;
}

.gp_package_list_container #sticky_cell_top_border {
  width: 70px !important;
  /* border-top: 7px solid #f5bf00 !important; */
  position: sticky !important;
  left: 0px !important;
}

.gp_package_list_container #sticky_col1 {
  width: 250px;
  /* border-top: 7px solid #f5bf00 !important; */
  position: sticky !important;
  left: 70px !important;
}

.group_list_container #sticky_cell_top_border {
  width: 40px;
  position: sticky !important;
  left: 0px !important;
}

.group_list_container #sticky_col1 {
  width: 250px;
  position: sticky !important;
  left: 70px !important;
}

.price_list_container #sticky_cell_top_border {
  width: 70px;
  position: sticky !important;
  left: 0px !important;
}

.price_list_container #sticky_col1 {
  width: 250px;
  position: sticky !important;
  left: 70px !important;
}

.disable_area {
  pointer-events: none;
  background-color: rgb(251, 248, 248) !important;
}

.pricing_table thead {
  position: sticky;
  background-color: white;
}

.pricing_table thead th:first-child {
  width: 70px;
  border-top: 7px solid #f5bf00 !important;
  position: sticky !important;
  left: 0 !important;
}

.pricing_table thead th:nth-child(2) {
  width: 200px;
  border-top: 7px solid #f5bf00 !important;
  position: sticky !important;
  left: 70px !important;
}

.pricing_table tbody td:first-child {
  position: sticky !important;
  left: 0 !important;
}

.pricing_table thead {
  z-index: 9999 !important;
}

.pricing_table tbody {
  position: relative;
  z-index: 999;
}

.media_menu_listing {
  font-size: 11px;
  color: rgb(158, 158, 158);
}

/* Responsive Style */
.pc_display {
  display: block !important;
}

.mobile_display {
  display: none !important;
}

.dragging-row {
  background-color: rgb(168, 77, 77) !important;
  cursor: move !important;
  color: blue !important;
}

.table {
  width: auto;
  table-layout: fixed;
  border-collapse: collapse;
  background-color: white;
}

.table th,
.table td {
  border: 1px solid #ccc;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.dragging-row {
  border: 2px dotted #f5bf00 !important;
  background-color: transparent !important;
  cursor: move;
  background-color: #a48204 !important;
  color: white !important;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
}

.dragging-row td:nth-child(1) {
  background-color: lightgray !important;
}

.dragtr {
  cursor: move;
}

.over {
  border: 2px dotted #f5bf00 !important;
  opacity: 1 !important;
  background-color: #a48204 !important;
}

.hb {
  background-color: black !important;
}

.css-154xyx0-MuiInputBase-root-MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
  border: none;
}

.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
  border: none;
}

.selected_service_list {
  background-color: white;
  border: 1px solid lightgray;
  border-radius: 8px;
  padding: 10px;
  color: gray;
  font-size: 90%;
}

.selected_service_list .selected_row {
  cursor: pointer;
  border-bottom: 1px solid lightgray;
}

.selected_service_list .selected_row:hover {
  background-color: rgb(252, 253, 252);
}

.add_service_btn {
  background-color: white;
  border: 1px solid lightgray !important;
  color: gray;
  border-radius: 8px;
  font-size: 80%;
  height: 35px;
}

.add_service_btn .addbox_icon {
  color: #f5bf00 !important;
  height: auto !important;
}

.MuiFormLabel-root.MuiInputLabel-root.MuiInputLabel-formControl.MuiInputLabel-animated.MuiInputLabel-outlined {
  color: gray;
  /* Replace 'red' with your desired label color */
}

/* Contact US Form */
.contact {
  max-height: 100vh;
  overflow: scroll;
  padding-bottom: 100px;
}

.contact p {
  font-size: 13px;
}

.contact input,
.contact label,
.contact textarea {
  font-size: 12px;
}

.contact textarea {
  border-radius: 0px !important;
  border: none;
}

.contact textarea:focus {
  box-shadow: none;
}

.contact_row .contact_sec1 {
  padding-top: 50px;
}

.contact_row .contact_sec2 {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.contact_row .text_line {
  height: 5px;
  width: auto;
  margin-top: -25px;
}

.contact_row .input_wrapper {
  overflow: hidden;
}

.textarea_wrapper {
  border: 1px solid lightgray;
  width: 100%;
  background-color: white;
}

.textarea_wrapper label {
  padding-left: 10px;
  font-size: 12px;
  color: gray;
  padding-bottom: 0px;
  margin-bottom: 0px;
}

.contact_row .contact_btn {
  width: 40%;
  font-size: 12px;
  background-color: #6188fe;
}

.media_links .media_gp {
  border-radius: 12px;
  color: white;
  font-size: 12px;
  background-color: #6188fe;
}

.media_links {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.media_links .icon_name {
  font-size: 10px;
  margin-top: 4px;
  margin-left: 3px;
}

.list_publish_btn {
  font-size: 10px !important;
}

/* Create category Form*/
.cat_textarea_wrapper {
  border-radius: 8px;
  border: 1px solid lightgray;
  width: 100%;
  background-color: white;
}

.cat_textarea_wrapper label {
  padding-left: 10px;
  font-size: 12px;
  color: gray;
  padding-bottom: 0px;
  margin-bottom: 0px;
}

.create_form_row textarea {
  border: none;
}

.create_form_row textarea:focus {
  box-shadow: none;
}

.create_category {
  height: 85vh;
}

.create_category .fixed_btn_gp {
  position: absolute;
  right: 5%;
  bottom: 5%;
}

.fixed_btn_gp .cancel_btn {
  color: gray !important;
  background-color: #edf0f5 !important;
}

.category_form input,
.category_form textarea,
.category_form select {
  font-size: 12px !important;
}

/* Sub category Form */
.create_scategory {
  height: 85vh;
}

.create_scategory .fixed_btn_gp {
  position: absolute;
  right: 5%;
  bottom: 5%;
}

.scategory_form input,
.scategory_form textarea,
.scategory_form select {
  font-size: 12px !important;
}

.switch_input_wrapper {
  border: 1px solid lightgray;
  border-radius: 8px;
  width: 100%;
  background-color: white;
  overflow: hidden;
}

.detail_view_img {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 75px;
  width: 75px;
  border-radius: 50px;
  border: 1px solid lightgray;
}

.detail_view_img img {
  height: 75px;
  width: 75px;
  border-radius: 50px;
  border: 1px solid lightgray;
  object-fit: cover;
}

.detail_view_img .img_upload_label {
  position: absolute;
  right: 0;
  bottom: -5px;
  padding: 2px;
  border-radius: 50px;
  background-color: #f5bf00;
}

.add_attrib_value {
  background-color: azure !important;
}

.select_business {
  color: gray !important;
}

.enable_validation {
  border: 2px solid red !important;
  background-color: rgb(253, 244, 246) !important;
  border-radius: 4px;
}

.items_per_page_select {
  border: 1px solid #aeaeae;
  padding: 3px 5px 3px 5px;
  width: 29px;
  -webkit-appearance: none;
  text-align: center;
  border-radius: 6px;
  color: #f5bf00 !important;
  font-size: 14px;
}

.items_per_page_select::-webkit-appearance {
  display: none;
}

.per-page-text {
  font-size: 16px;
  color: #969696;
}

.items_per_page_select:focus {
  border: none;
  outline: none;
}

.items_per_page_select option:hover {
  background-color: #f5bf00 !important;
  color: white !important;
}

.column_main_wrapper {
  max-height: 70vh;
  overflow-y: scroll;
}

.col_btn_div {
  height: 60px;
  width: 300px;
}

.col_btn_div button {
  border: 2px solid #f5bf00 !important;
}

.col_btn_div button:hover {
  background-color: #facf35;
  border: 2px solid #facf35 !important;
}

.list_col_container {
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  height: 95vh;
  padding-bottom: 100px;
}

.selectedColumn {
  background-color: #f5bf00;
}

.col_blue_btn_div {
  height: 60px;
  width: 300px;
}

.selectedColumnBlue {
  background-color: #548dff;
}

.col_blue_btn_div button {
  border: 2px solid #548dff !important;
}

.col_blue_btn_div button:hover {
  background-color: #548dff;
}

.add_blue_btn {
  background-color: white;
  border: 1px solid lightgray !important;
  color: gray;
  border-radius: 8px;
  font-size: 80%;
  height: 35px;
}

.add_blue_btn .addbox_blue_icon {
  color: #548dff !important;
  height: auto !important;
}

.add_yellow_btn {
  background-color: white;
  border: 1px solid lightgray !important;
  color: gray;
  border-radius: 8px;
  font-size: 80%;
  height: 35px;
}

.add_yellow_btn .addbox_yellow_icon {
  color: #f5bf00 !important;
  height: auto !important;
}

.selectedColumnyellow {
  background-color: #f5bf00;
}

.scrollable_col_list {
  display: flex;
  list-style: none;
  max-width: 88vw;
  overflow-x: scroll;
  border: 2px dotted #f5bf00;
  height: 40px;
  width: 100%;
}

.scrollable_col_list::-webkit-scrollbar {
  display: none;
}

.scrollable_div {
  padding-left: 60px !important;
  padding-right: 60px !important;
}

@media screen and (max-width: 576px) {
  .pc_display {
    display: none !important;
  }
  .mobile_display {
    display: block !important;
  }
  .service_header_mobile p {
    font-size: 12px;
    margin-top: -10px;
  }
  .service_header_mobile button {
    font-size: 12px !important;
    padding: 2px 12px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/Assets/components/serviceInventory/services.scss"],"names":[],"mappings":"AAAA;EAGE,6BAAA;AADF;;AAMA;EACE,gBAAA;EACA,OAAA;AAHF;;AAMA;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,SAAA;EACA,UAAA;AAHF;;AAMA;EACE,oBAAA;EACA,uBAAA;AAHF;;AAOA;;EAEE,yBAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;AAJF;;AAOA;;;;;;;;;EASE,wBAAA;AAJF;;AAOA;EACE,gBAAA;EACA,gBAAA;EACA,qBAAA;AAJF;;AAOA;EACE,mBAAA;EACA,yBAAA;EACA,uBAAA;EACA,sCAAA;AAJF;;AAOA;;EAEE,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,sBAAA;AAJF;;AAOA;;;;EAIE,4BAAA;EACA,sBAAA;EACA,oCAAA;AAJF;;AAOA;EACE,aAAA;EACA,eAAA;AAJF;;AAOA;EACE,yBAAA;AAJF;;AAOA;;EAEE,gCAAA;EACA,6BAAA;EACA,WAAA;AAJF;;AAOA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AAJF;;AAOA,qBAAA;AAEA;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;AALF;;AAQA;EACE,WAAA;EACA,6BAAA;EACA,gBAAA;EACA,WAAA;EACA,UAAA;AALF;;AAQA;EACE,YAAA;EACA,6BAAA;EACA,gBAAA;EACA,UAAA;EACA,UAAA;EACA,eAAA;AALF;;AAQA;EACE,gBAAA;EACA,WAAA;EACA,UAAA;AALF;;AAQA;EACE,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;AALF;;AAQA;EACE,oCAAA;AALF;;AAQA;EACE,gBAAA;EACA,UAAA;EACA,UAAA;AALF;;AAQA;EACE,WAAA;AALF;;AAQA;;EAEE,YAAA;EACA,eAAA;EACA,sBAAA;AALF;;AAQA,0BAAA;AACA;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,uBAAA;AALF;;AAQA;EACE,WAAA;EACA,6BAAA;EACA;iBAAA;AAJF;;AAQA;EACE,YAAA;EACA,6BAAA;EACA;iBAAA;AAJF;;AAQA;EACE;;iBAAA;AAHF;;AAQA;EACE;;iBAAA;AAHF;;AAQA;;EAEE,WAAA;EACA,gBAAA;EAEA,oCAAA;AANF;;AASA;;EAEE,YAAA;EACA,eAAA;EACA,sBAAA;AANF;;AASA,yCAAA;AAEA;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;AAPF;;AAUA;EACE,WAAA;EACA,6BAAA;EACA,gBAAA;EACA,UAAA;EACA,UAAA;AAPF;;AAUA;EACE,uBAAA;EACA,6BAAA;EACA,gBAAA;EACA,UAAA;EACA,UAAA;AAPF;;AAUA;EACE,gBAAA;EACA,UAAA;EACA,UAAA;AAPF;;AAUA;EACE,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;AAPF;;AAUA;EACE,oCAAA;AAPF;;AAUA;EAEE,SAAA;EACA,UAAA;EACA,eAAA;AARF;;AAWA;EACE,yBAAA;AARF;;AAWA;EACE,WAAA;AARF;;AAWA;;EAEE,YAAA;EACA,eAAA;EACA,sBAAA;AARF;;AAWA,6CAAA;AACA;EAEE,SAAA;EACA,UAAA;EACA,uBAAA;AATF;;AAYA;EACE,WAAA;EACA,6BAAA;EACA;iBAAA;AARF;;AAYA;EACE,YAAA;EACA,6BAAA;EACA;iBAAA;AARF;;AAYA;EACE;;iBAAA;AAPF;;AAYA;EACE;;iBAAA;AAPF;;AAYA;EACE,yBAAA;AATF;;AAYA;;EAEE,WAAA;EACA,gBAAA;EACA,WAAA;EACA,oCAAA;AATF;;AAYA;;EAEE,YAAA;EACA,eAAA;EACA,sBAAA;AATF;;AAYA,8BAAA;AACA;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,uBAAA;AATF;;AAYA;EACE,WAAA;EACA,6BAAA;EACA,gBAAA;EACA,UAAA;EACA,UAAA;AATF;;AAYA;EACE,YAAA;EACA,6BAAA;EACA,gBAAA;EACA,UAAA;EACA,UAAA;AATF;;AAYA;EACE,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;AATF;;AAYA;EACE,oCAAA;AATF;;AAYA;EACE,gBAAA;EACA,UAAA;EACA,UAAA;AATF;;AAYA;EACE,gBAAA;EACA,UAAA;EACA,UAAA;AATF;;AAYA;EACE,WAAA;AATF;;AAYA;;EAEE,YAAA;EACA,eAAA;EACA,sBAAA;AATF;;AAYA,mCAAA;AACA;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,uBAAA;AATF;;AAYA;EACE,WAAA;EACA,6BAAA;EACA;iBAAA;AARF;;AAYA;EACE,YAAA;EACA,6BAAA;EACA;iBAAA;AARF;;AAYA;EACE;;iBAAA;AAPF;;AAYA;EACE;;iBAAA;AAPF;;AAYA;;EAEE,WAAA;EACA,gBAAA;EACA,WAAA;EACA,oCAAA;AATF;;AAYA;;EAEE,YAAA;EACA,eAAA;EACA,sBAAA;AATF;;AAYA,8BAAA;AACA;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,uBAAA;AATF;;AAYA;EACE,WAAA;EACA,mCAAA;EACA,gBAAA;EACA,UAAA;EACA,UAAA;AATF;;AAYA;EACE,YAAA;EACA,mCAAA;EACA,gBAAA;EACA,UAAA;EACA,UAAA;AATF;;AAYA;EACE,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;AATF;;AAYA;EACE,oCAAA;AATF;;AAYA;EACE,gBAAA;EACA,UAAA;EACA,UAAA;AATF;;AAYA;EACE,gBAAA;EACA,UAAA;EACA,UAAA;AATF;;AAYA;EACE,WAAA;AATF;;AAYA;;EAEE,YAAA;EACA,eAAA;EACA,sBAAA;AATF;;AAYA,mCAAA;AACA;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,uBAAA;AATF;;AAYA;EACE,WAAA;EACA,mCAAA;EACA;iBAAA;AARF;;AAYA;EACE,YAAA;EACA,mCAAA;EACA;iBAAA;AARF;;AAYA;EACE;;iBAAA;AAPF;;AAYA;EACE;;iBAAA;AAPF;;AAYA;;EAEE,WAAA;EACA,gBAAA;EACA,WAAA;EACA,oCAAA;AATF;;AAYA;;EAEE,YAAA;EACA,eAAA;EACA,sBAAA;AATF;;AAYA,2BAAA;AACA;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,uBAAA;AATF;;AAYA;EACE,WAAA;EACA,6BAAA;EACA,gBAAA;EACA,UAAA;EACA,UAAA;AATF;;AAYA;EACE,YAAA;EACA,6BAAA;EACA,gBAAA;EACA,UAAA;EACA,UAAA;AATF;;AAYA;EACE,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;AATF;;AAYA;EACE,oCAAA;AATF;;AAYA;EACE,gBAAA;EACA,UAAA;EACA,UAAA;AATF;;AAYA;EACE,gBAAA;EACA,UAAA;EACA,UAAA;AATF;;AAYA;EACE,WAAA;AATF;;AAYA;;EAEE,YAAA;EACA,eAAA;EACA,sBAAA;AATF;;AAYA,gCAAA;AACA;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,uBAAA;AATF;;AAYA;EACE,WAAA;EACA,6BAAA;EACA;iBAAA;AARF;;AAYA;EACE,YAAA;EACA,6BAAA;EACA;iBAAA;AARF;;AAYA;EACE;;iBAAA;AAPF;;AAYA;EACE;;iBAAA;AAPF;;AAYA;;EAEE,WAAA;EACA,gBAAA;EACA,WAAA;EACA,oCAAA;AATF;;AAYA;;EAEE,YAAA;EACA,eAAA;EACA,sBAAA;AATF;;AAYA,gCAAA;AACA;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,uBAAA;AATF;;AAYA;EACE,WAAA;EACA,6BAAA;EACA,gBAAA;EACA,UAAA;EACA,UAAA;AATF;;AAYA;EACE,YAAA;EACA,6BAAA;EACA,gBAAA;EACA,UAAA;EACA,UAAA;AATF;;AAYA;EACE,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;AATF;;AAYA;EAGE,oCAAA;AAXF;;AAcA;EACE,gBAAA;EACA,UAAA;EACA,UAAA;AAXF;;AAcA;EACE,gBAAA;EACA,UAAA;EACA,UAAA;AAXF;;AAcA;EACE,WAAA;AAXF;;AAcA;;EAEE,YAAA;EACA,eAAA;EACA,sBAAA;AAXF;;AAcA,qCAAA;AACA;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,uBAAA;AAXF;;AAcA;EACE,WAAA;EACA,6BAAA;EACA;iBAAA;AAVF;;AAcA;EACE,YAAA;EACA,6BAAA;EACA;iBAAA;AAVF;;AAcA;EACE;;iBAAA;AATF;;AAcA;EACE;;iBAAA;AATF;;AAcA;;EAEE,WAAA;EACA,gBAAA;EACA,WAAA;EACA,oCAAA;AAXF;;AAcA;;EAEE,YAAA;EACA,eAAA;EACA,sBAAA;AAXF;;AAcA,8BAAA;AACA;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,uBAAA;AAXF;;AAcA;EACE,WAAA;EACA,gBAAA;EACA,UAAA;EACA,UAAA;AAXF;;AAcA;EACE,YAAA;EACA,gBAAA;EACA,UAAA;EACA,UAAA;AAXF;;AAcA;EACE,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;AAXF;;AAcA;EACE,oCAAA;AAXF;;AAcA;EACE,gBAAA;EACA,UAAA;EACA,UAAA;AAXF;;AAcA;EACE,gBAAA;EACA,UAAA;EACA,UAAA;AAXF;;AAcA;EACE,WAAA;AAXF;;AAcA;;EAEE,YAAA;EACA,eAAA;EACA,sBAAA;AAXF;;AAcA,mCAAA;AACA;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,uBAAA;AAXF;;AAcA;EACE,WAAA;EACA,mCAAA;EACA;iBAAA;AAVF;;AAcA;EACE,YAAA;EACA,mCAAA;EACA;iBAAA;AAVF;;AAcA;EACE;;iBAAA;AATF;;AAcA;EACE;;iBAAA;AATF;;AAcA;;EAEE,WAAA;EACA,gBAAA;EACA,WAAA;EACA,oCAAA;AAXF;;AAcA;;EAEE,YAAA;EACA,eAAA;EACA,sBAAA;AAXF;;AAcA,4BAAA;AACA;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,uBAAA;AAXF;;AAcA;EACE,WAAA;EACA,mCAAA;EACA,gBAAA;EACA,UAAA;EACA,UAAA;AAXF;;AAcA;EACE,YAAA;EACA,mCAAA;EACA,gBAAA;EACA,UAAA;EACA,UAAA;AAXF;;AAcA;EACE,gBAAA;EACA,UAAA;EACA,UAAA;AAXF;;AAcA;EACE,gBAAA;EACA,UAAA;EACA,UAAA;AAXF;;AAcA;EACE,sBAAA;AAXF;;AAcA;;EAEE,YAAA;EACA,eAAA;EACA,sBAAA;AAXF;;AAcA,gCAAA;AACA;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,uBAAA;AAXF;;AAcA;EACE,WAAA;EACA,mCAAA;EACA;iBAAA;AAVF;;AAcA;EACE,YAAA;EACA,mCAAA;EACA;iBAAA;AAVF;;AAcA;EACE;;iBAAA;AATF;;AAcA;EACE;;iBAAA;AATF;;AAcA;;EAEE,WAAA;EACA,gBAAA;EACA,WAAA;EACA,oCAAA;AAXF;;AAcA;;EAEE,YAAA;EACA,eAAA;EACA,sBAAA;AAXF;;AAcA,mBAAA;AACA;EACE,aAAA;EACA,kBAAA;EACA,qBAAA;EACA,WAAA;AAXF;;AAcA;;EAEE,YAAA;EACA,eAAA;AAXF;;AAcA;;EAEE,gBAAA;EACA,aAAA;EACA,YAAA;AAXF;;AAcA;;EAEE,YAAA;EACA,eAAA;AAXF;;AAcA;;EAEE,gBAAA;EACA,aAAA;EACA,YAAA;AAXF;;AAcA;EACE,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,8BAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;AAXF;;AAcA;EACE,gBAAA;EACA,eAAA;EACA,gCAAA;AAXF;;AAcA;;EAEE,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yCAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;AAXF;;AAcA;;EAEE,2CAAA;AAXF;;AAcA;EACE,iBAAA;EACA,mBAAA;EACA,6BAAA;AAXF;;AAcA;EACE,kBAAA;EACA,oBAAA;AAXF;;AAcA;EACE,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;AAXF;;AAcA;EACE,gBAAA;AAXF;;AAcA;EACE,sBAAA;EACA,mBAAA;AAXF;;AAcA;;EAEE,6BAAA;EACA,YAAA;EACA,WAAA;AAXF;;AAcA;EACE,kBAAA;EACA,UAAA;EACA,UAAA;AAXF;;AAcA;EACE,sBAAA;AAXF;;AAcA;EACE,sBAAA;EACA,8CAAA;EACA,2BAAA;EACA,oBAAA;AAXF;;AAcA;EACE,YAAA;EACA,8CAAA;EACA,2BAAA;EACA,qBAAA;AAXF;;AAcA;EACE,WAAA;EACA,2BAAA;EACA,oBAAA;AAXF;;AAcA;EACE,YAAA;EACA,2BAAA;EACA,qBAAA;AAXF;;AAcA;EACE,WAAA;EACA,2BAAA;EACA,oBAAA;AAXF;;AAcA;EACE,YAAA;EACA,2BAAA;EACA,qBAAA;AAXF;;AAcA;EACE,oBAAA;EACA,+CAAA;AAXF;;AAcA;EACE,gBAAA;EACA,uBAAA;AAXF;;AAcA;EACE,WAAA;EACA,wCAAA;EACA,2BAAA;EACA,kBAAA;AAXF;;AAcA;EACE,YAAA;EACA,wCAAA;EACA,2BAAA;EACA,qBAAA;AAXF;;AAcA;EACE,2BAAA;EACA,kBAAA;AAXF;;AAcA;EACE,wBAAA;AAXF;;AAcA;EACE,kBAAA;EACA,YAAA;AAXF;;AAcA;EACE,eAAA;EACA,yBAAA;AAXF;;AAcA,qBAAA;AACA;EACE,yBAAA;AAXF;;AAcA;EACE,wBAAA;AAXF;;AAcA;EACE,6CAAA;EACA,uBAAA;EACA,sBAAA;AAXF;;AAcA;EACE,WAAA;EACA,mBAAA;EACA,yBAAA;EACA,uBAAA;AAXF;;AAcA;;EAEE,sBAAA;EACA,mBAAA;EACA,uBAAA;AAXF;;AAcA;EACE,qCAAA;EACA,wCAAA;EACA,YAAA;EACA,oCAAA;EACA,uBAAA;EACA,2CAAA;AAXF;;AAcA;EACE,sCAAA;AAXF;;AAcA;EACE,YAAA;AAXF;;AAcA;EACE,qCAAA;EACA,qBAAA;EACA,oCAAA;AAXF;;AAcA;EACE,kCAAA;AAXF;;AAcA;EAGE,YAAA;AAbF;;AAiBA;EAEE,YAAA;AAfF;;AAoBA;EACE,uBAAA;EACA,2BAAA;EACA,kBAAA;EACA,aAAA;EACA,WAAA;EACA,cAAA;AAjBF;;AAoBA;EACE,eAAA;EACA,kCAAA;AAjBF;;AAoBA;EACE,oCAAA;AAjBF;;AAoBA;EACE,uBAAA;EACA,sCAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;EACA,YAAA;AAjBF;;AAoBA;EACE,yBAAA;EACA,uBAAA;AAjBF;;AAoBA;EACE,WAAA;EACA,gDAAA;AAjBF;;AAoBA,oBAAA;AACA;EACE,iBAAA;EACA,gBAAA;EACA,qBAAA;AAjBF;;AAoBA;EACE,eAAA;AAjBF;;AAoBA;;;EAGE,eAAA;AAjBF;;AAoBA;EACE,6BAAA;EACA,YAAA;AAjBF;;AAoBA;EACE,gBAAA;AAjBF;;AAoBA;EACE,iBAAA;AAjBF;;AAoBA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AAjBF;;AAoBA;EACE,WAAA;EACA,WAAA;EACA,iBAAA;AAjBF;;AAoBA;EACE,gBAAA;AAjBF;;AAoBA;EACE,2BAAA;EACA,WAAA;EACA,uBAAA;AAjBF;;AAoBA;EACE,kBAAA;EACA,eAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;AAjBF;;AAoBA;EACE,UAAA;EACA,eAAA;EACA,yBAAA;AAjBF;;AAoBA;EACE,mBAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;AAjBF;;AAoBA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AAjBF;;AAoBA;EACE,eAAA;EACA,eAAA;EACA,gBAAA;AAjBF;;AAoBA;EACE,0BAAA;AAjBF;;AAoBA,wBAAA;AAEA;EACE,kBAAA;EACA,2BAAA;EACA,WAAA;EACA,uBAAA;AAlBF;;AAqBA;EACE,kBAAA;EACA,eAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;AAlBF;;AAqBA;EACE,YAAA;AAlBF;;AAqBA;EACE,gBAAA;AAlBF;;AAqBA;EACE,YAAA;AAlBF;;AAqBA;EACE,kBAAA;EACA,SAAA;EACA,UAAA;AAlBF;;AAqBA;EACE,sBAAA;EACA,oCAAA;AAlBF;;AAqBA;;;EAGE,0BAAA;AAlBF;;AAqBA,sBAAA;AACA;EACE,YAAA;AAlBF;;AAqBA;EACE,kBAAA;EACA,SAAA;EACA,UAAA;AAlBF;;AAqBA;;;EAGE,0BAAA;AAlBF;;AAqBA;EACE,2BAAA;EACA,kBAAA;EACA,WAAA;EACA,uBAAA;EACA,gBAAA;AAlBF;;AAqBA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,2BAAA;AAlBF;;AAqBA;EACE,YAAA;EACA,WAAA;EACA,mBAAA;EACA,2BAAA;EACA,iBAAA;AAlBF;;AAqBA;EACE,kBAAA;EACA,QAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;AAlBF;;AAqBA;EACE,kCAAA;AAlBF;;AAqBA;EAEE,sBAAA;AAnBF;;AAsBA;EACE,gCAAA;EACA,+CAAA;EACA,kBAAA;AAnBF;;AA2BA;EACE,yBAAA;EACA,wBAAA;EACA,WAAA;EACA,wBAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,eAAA;AAxBF;;AA0BA;EACE,aAAA;AAvBF;;AAyBA;EACE,eAAA;EACA,cAAA;AAtBF;;AAyBA;EACE,YAAA;EACA,aAAA;AAtBF;;AAyBA;EACE,oCAAA;EACA,uBAAA;AAtBF;;AAyBA;EACE,gBAAA;EACA,kBAAA;AAtBF;;AAyBA;EACE,YAAA;EACA,YAAA;AAtBF;;AAyBA;EACE,oCAAA;AAtBF;;AAyBA;EACE,yBAAA;EACA,oCAAA;AAtBF;;AAyBA;EACE,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,YAAA;EACA,qBAAA;AAtBF;;AAyBA;EACE,yBAAA;AAtBF;;AAyBA;EACE,YAAA;EACA,YAAA;AAtBF;;AAyBA;EACE,yBAAA;AAtBF;;AAyBA;EACE,oCAAA;AAtBF;;AAyBA;EACE,yBAAA;AAtBF;;AAyBA;EACE,uBAAA;EACA,sCAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;EACA,YAAA;AAtBF;;AAyBA;EACE,yBAAA;EACA,uBAAA;AAtBF;;AAyBA;EACE,uBAAA;EACA,sCAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;EACA,YAAA;AAtBF;;AAyBA;EACE,yBAAA;EACA,uBAAA;AAtBF;;AAyBA;EACE,yBAAA;AAtBF;;AAyBA;EACE,aAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,0BAAA;EACA,YAAA;EACA,WAAA;AAtBF;;AAyBA;EACE,aAAA;AAtBF;;AAyBA;EACE,6BAAA;EACA,8BAAA;AAtBF;;AAyBA;EACE;IACE,wBAAA;EAtBF;EAyBA;IACE,yBAAA;EAvBF;EA0BA;IACE,eAAA;IACA,iBAAA;EAxBF;EA2BA;IACE,0BAAA;IACA,4BAAA;EAzBF;AACF","sourcesContent":[".table-container {\n  // overflow: auto;\n  // max-width: 100%;\n  border-radius: 7px !important;\n  //   box-shadow: 3px 5px 0px #c6c5c5 !important;\n  // overflow: scroll !important;\n}\n\n.sticky_header {\n  position: sticky;\n  left: 0;\n}\n\n.sticky_row {\n  position: sticky;\n  bottom: 0;\n  z-index: 4;\n  margin: 0;\n  padding: 0;\n}\n\n.sticky_row td {\n  margin: 0 !important;\n  padding: 7px !important;\n  //  vertical-align: middle !important;\n}\n\n.sticky_row input,\n.sticky_row select {\n  background-color: #f5f5f5;\n  color: black;\n  height: 35px;\n  width: 100%;\n}\n\n.hide_scrollbar::-webkit-scrollbar,\n.inv_list_container::-webkit-scrollbar,\n.price_list_container::-webkit-scrollbar,\n.group_list_container::-webkit-scrollbar,\n.packages_table_container::-webkit-scrollbar,\n.gp_pkg_list_container::-webkit-scrollbar,\n.package_list_container::-webkit-scrollbar,\n.package_list_container_mobile::-webkit-scrollbar,\n.form_main_container::-webkit-scrollbar {\n  display: none !important;\n}\n\n.form_main_container {\n  max-height: 95vh;\n  overflow: scroll;\n  padding-bottom: 100px;\n}\n\n.table {\n  table-layout: fixed;\n  border-collapse: collapse;\n  background-color: white;\n  border-top-left-radius: 9px !important;\n}\n\n.table th,\n.table td {\n  border: 1px solid #ccc;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  position: relative;\n  vertical-align: middle;\n}\n\n#table_form_row td,\n#table_form_row td,\n#table_form_row td input,\n#table_form_row td select {\n  font-weight: bold !important;\n  color: gray !important;\n  background-color: rgb(252, 250, 250);\n}\n\n.list_wrapper {\n  padding: 20px;\n  font-size: 14px;\n}\n\n.list_wrapper .row:hover {\n  background-color: #f8fafc;\n}\n\n.list_wrapper .row .col,\n.list_wrapper .row .check_col {\n  border-bottom: 1px solid #e7e8ea;\n  background-color: transparent;\n  color: gray;\n}\n\n.switch_btn_div {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n/*List style for PC */\n\n.table_main_list thead {\n  position: sticky;\n  top: -4px;\n  z-index: 3;\n  background-color: white;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.table_main_list th:nth-child(1) {\n  width: 70px;\n  border-top: 7px solid #f5bf00;\n  position: sticky;\n  left: -12px;\n  z-index: 4;\n}\n\n.table_main_list th:nth-child(2) {\n  width: 250px;\n  border-top: 7px solid #f5bf00;\n  position: sticky;\n  left: 58px;\n  z-index: 4;\n  cursor: pointer;\n}\n\n.table_main_list td:nth-child(1) {\n  position: sticky;\n  left: -12px;\n  z-index: 2;\n}\n\n.table_main_list td:nth-child(1) .checkbox_btn[type=\"checkbox\"] {\n  margin-top: -4px;\n  margin-left: -20px;\n  height: 18px;\n  width: 18px;\n}\n\n.table_main_list td:nth-child(1) .checkbox_btn[type=\"checkbox\"]:checked {\n  background-color: #f5bf00 !important;\n}\n\n.table_main_list #sticky_col0 {\n  position: sticky;\n  left: 58px;\n  z-index: 2;\n}\n\n.table_main_list th:last-child {\n  width: 60px;\n}\n\n.table_main_list th,\n.table_main_list td {\n  width: 120px;\n  font-size: 12px;\n  color: gray !important;\n}\n\n/* List style for Mobile */\n.table_main_list_mobile thead {\n  position: sticky;\n  top: -4px;\n  z-index: 3;\n  background-color: white;\n}\n\n.table_main_list_mobile th:nth-child(1) {\n  width: 70px;\n  border-top: 7px solid #f5bf00;\n  /* position: sticky;\n    left: -2px; */\n}\n\n.table_main_list_mobile th:nth-child(2) {\n  width: 250px;\n  border-top: 7px solid #f5bf00;\n  /* position: sticky;\n    left: 67px; */\n}\n\n.table_main_list_mobile td:nth-child(1) {\n  /* position: sticky;;\n    left: -2px;\n    z-index: 2; */\n}\n\n.table_main_list_mobile #sticky_col0 {\n  /* position: sticky;\n    left: 67px;\n    z-index: 2; */\n}\n\n.table_main_list_mobile th:last-child,\n.table_main_list_mobile td:last-child {\n  width: 60px;\n  position: sticky;\n  //  right: -2px;\n  background-color: rgb(245, 241, 241);\n}\n\n.table_main_list_mobile th,\n.table_main_list_mobile td {\n  width: 120px;\n  font-size: 12px;\n  color: gray !important;\n}\n\n/* Inventory Services List style for PC */\n\n.inv_list_container thead {\n  position: sticky;\n  top: -4px;\n  z-index: 3;\n  background-color: white;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.inv_list_container th:nth-child(1) {\n  width: 60px;\n  border-top: 7px solid #ff9669;\n  position: sticky;\n  left: -2px;\n  z-index: 4;\n}\n\n.inv_list_container th:nth-child(2) {\n  width: 250px !important;\n  border-top: 7px solid #ff9669;\n  position: sticky;\n  left: 67px;\n  z-index: 4;\n}\n\n.inv_list_container td:nth-child(1) {\n  position: sticky;\n  left: -2px;\n  z-index: 2;\n}\n\n.inv_list_container td:nth-child(1) .checkbox_btn[type=\"checkbox\"] {\n  margin-top: -4px;\n  margin-left: -20px;\n  height: 18px;\n  width: 18px;\n}\n\n.inv_list_container td:nth-child(1) .checkbox_btn[type=\"checkbox\"]:checked {\n  background-color: #f5bf00 !important;\n}\n\n.inv_list_container #sticky_col0 {\n  //  position: sticky;\n  left: 0px;\n  z-index: 2;\n  cursor: pointer;\n}\n\n.inv_list_container #sticky_col0:hover {\n  color: #f5bf00 !important;\n}\n\n.inv_list_container th:last-child {\n  width: 60px;\n}\n\n.inv_list_container th,\n.inv_list_container td {\n  width: 120px;\n  font-size: 12px;\n  color: gray !important;\n}\n\n/* Inventory Services List style for Mobile */\n.inv_list_container_mobile thead {\n  //  position: sticky;\n  top: -4px;\n  z-index: 3;\n  background-color: white;\n}\n\n.inv_list_container_mobile th:nth-child(1) {\n  width: 70px;\n  border-top: 7px solid #f5bf00;\n  /* position: sticky;\n    left: -2px; */\n}\n\n.inv_list_container_mobile th:nth-child(2) {\n  width: 250px;\n  border-top: 7px solid #f5bf00;\n  /* position: sticky;\n    left: 67px; */\n}\n\n.inv_list_container_mobile td:nth-child(1) {\n  /* position: sticky;;\n    left: -2px;\n    z-index: 2; */\n}\n\n.inv_list_container_mobile #sticky_col0 {\n  /* position: sticky;\n    left: 67px;\n    z-index: 2; */\n}\n\n.inv_list_container_mobile #sticky_col0:hover {\n  color: #f5bf00 !important;\n}\n\n.inv_list_container_mobile th:last-child,\n.inv_list_container_mobile td:last-child {\n  width: 60px;\n  position: sticky;\n  right: -2px;\n  background-color: rgb(245, 241, 241);\n}\n\n.inv_list_container_mobile th,\n.inv_list_container_mobile td {\n  width: 120px;\n  font-size: 12px;\n  color: gray !important;\n}\n\n/* Pricing Form style for PC */\n.pricing_form_container thead {\n  position: sticky;\n  top: -4px;\n  z-index: 3;\n  background-color: white;\n}\n\n.pricing_form_container th:nth-child(1) {\n  width: 70px;\n  border-top: 7px solid #f5bf00;\n  position: sticky;\n  left: -2px;\n  z-index: 4;\n}\n\n.pricing_form_container th:nth-child(2) {\n  width: 250px;\n  border-top: 7px solid #f5bf00;\n  position: sticky;\n  left: 67px;\n  z-index: 4;\n}\n\n.pricing_form_container td:nth-child(1) .checkbox_btn[type=\"checkbox\"] {\n  margin-top: -4px;\n  margin-left: -20px;\n  height: 18px;\n  width: 18px;\n}\n\n.pricing_form_container td:nth-child(1) .checkbox_btn[type=\"checkbox\"]:checked {\n  background-color: #f5bf00 !important;\n}\n\n.pricing_form_container td:nth-child(1) {\n  position: sticky;\n  left: -2px;\n  z-index: 2;\n}\n\n.pricing_form_container #sticky_col0 {\n  position: sticky;\n  left: 67px;\n  z-index: 2;\n}\n\n.pricing_form_container th:last-child {\n  width: 60px;\n}\n\n.pricing_form_container th,\n.pricing_form_container td {\n  width: 120px;\n  font-size: 12px;\n  color: gray !important;\n}\n\n/*  Pricing form style for Mobile */\n.pricing_form_container_mobile thead {\n  position: sticky;\n  top: -4px;\n  z-index: 3;\n  background-color: white;\n}\n\n.pricing_form_container_mobile th:nth-child(1) {\n  width: 70px;\n  border-top: 7px solid #f5bf00;\n  /* position: sticky;\n    left: -2px; */\n}\n\n.pricing_form_container_mobile th:nth-child(2) {\n  width: 250px;\n  border-top: 7px solid #f5bf00;\n  /* position: sticky;\n    left: 67px; */\n}\n\n.pricing_form_container_mobile td:nth-child(1) {\n  /* position: sticky;;\n    left: -2px;\n    z-index: 2; */\n}\n\n.pricing_form_container_mobile #sticky_col0 {\n  /* position: sticky;\n    left: 67px;\n    z-index: 2; */\n}\n\n.pricing_form_container_mobile th:last-child,\n.pricing_form_container_mobile td:last-child {\n  width: 60px;\n  position: sticky;\n  right: -2px;\n  background-color: rgb(245, 241, 241);\n}\n\n.pricing_form_container_mobile th,\n.pricing_form_container_mobile td {\n  width: 120px;\n  font-size: 12px;\n  color: gray !important;\n}\n\n/* Pricing list style for PC */\n.pricing_list_container thead {\n  position: sticky;\n  top: -4px;\n  z-index: 3;\n  background-color: white;\n}\n\n.pricing_list_container th:nth-child(1) {\n  width: 70px;\n  /* border-top: 7px solid #f5bf00; */\n  position: sticky;\n  left: -2px;\n  z-index: 4;\n}\n\n.pricing_list_container th:nth-child(2) {\n  width: 250px;\n  /* border-top: 7px solid #f5bf00; */\n  position: sticky;\n  left: 67px;\n  z-index: 4;\n}\n\n.pricing_list_container td:nth-child(1) .checkbox_btn[type=\"checkbox\"] {\n  margin-top: -4px;\n  margin-left: -20px;\n  height: 18px;\n  width: 18px;\n}\n\n.pricing_list_container td:nth-child(1) .checkbox_btn[type=\"checkbox\"]:checked {\n  background-color: #f5bf00 !important;\n}\n\n.pricing_list_container td:nth-child(1) {\n  position: sticky;\n  left: -2px;\n  z-index: 2;\n}\n\n.pricing_list_container #sticky_col0 {\n  position: sticky;\n  left: 67px;\n  z-index: 2;\n}\n\n.pricing_list_container th:last-child {\n  width: 60px;\n}\n\n.pricing_list_container th,\n.pricing_list_container td {\n  width: 120px;\n  font-size: 12px;\n  color: gray !important;\n}\n\n/*  Pricing list style for Mobile */\n.pricing_list_container_mobile thead {\n  position: sticky;\n  top: -4px;\n  z-index: 3;\n  background-color: white;\n}\n\n.pricing_list_container_mobile th:nth-child(1) {\n  width: 70px;\n  /* border-top: 7px solid #f5bf00; */\n  /* position: sticky;\n    left: -2px; */\n}\n\n.pricing_list_container_mobile th:nth-child(2) {\n  width: 250px;\n  /* border-top: 7px solid #f5bf00; */\n  /* position: sticky;\n    left: 67px; */\n}\n\n.pricing_list_container_mobile td:nth-child(1) {\n  /* position: sticky;;\n    left: -2px;\n    z-index: 2; */\n}\n\n.pricing_list_container_mobile #sticky_col0 {\n  /* position: sticky;\n    left: 67px;\n    z-index: 2; */\n}\n\n.pricing_list_container_mobile th:last-child,\n.pricing_list_container_mobile td:last-child {\n  width: 60px;\n  position: sticky;\n  right: -2px;\n  background-color: rgb(245, 241, 241);\n}\n\n.pricing_list_container_mobile th,\n.pricing_list_container_mobile td {\n  width: 120px;\n  font-size: 12px;\n  color: gray !important;\n}\n\n/* Cost Form style for PC */\n.cost_form_container thead {\n  position: sticky;\n  top: -4px;\n  z-index: 3;\n  background-color: white;\n}\n\n.cost_form_container th:nth-child(1) {\n  width: 70px;\n  border-top: 7px solid #f5bf00;\n  position: sticky;\n  left: -2px;\n  z-index: 4;\n}\n\n.cost_form_container th:nth-child(2) {\n  width: 250px;\n  border-top: 7px solid #f5bf00;\n  position: sticky;\n  left: 67px;\n  z-index: 4;\n}\n\n.cost_form_container td:nth-child(1) .checkbox_btn[type=\"checkbox\"] {\n  margin-top: -4px;\n  margin-left: -20px;\n  height: 18px;\n  width: 18px;\n}\n\n.cost_form_container td:nth-child(1) .checkbox_btn[type=\"checkbox\"]:checked {\n  background-color: #f5bf00 !important;\n}\n\n.cost_form_container td:nth-child(1) {\n  position: sticky;\n  left: -2px;\n  z-index: 2;\n}\n\n.cost_form_container #sticky_col0 {\n  position: sticky;\n  left: 67px;\n  z-index: 2;\n}\n\n.cost_form_container th:last-child {\n  width: 60px;\n}\n\n.cost_form_container th,\n.cost_form_container td {\n  width: 120px;\n  font-size: 12px;\n  color: gray !important;\n}\n\n/*  Cost form style for Mobile */\n.cost_form_container_mobile thead {\n  position: sticky;\n  top: -4px;\n  z-index: 3;\n  background-color: white;\n}\n\n.cost_form_container_mobile th:nth-child(1) {\n  width: 70px;\n  border-top: 7px solid #f5bf00;\n  /* position: sticky;\n    left: -2px; */\n}\n\n.cost_form_container_mobile th:nth-child(2) {\n  width: 250px;\n  border-top: 7px solid #f5bf00;\n  /* position: sticky;\n    left: 67px; */\n}\n\n.cost_form_container_mobile td:nth-child(1) {\n  /* position: sticky;;\n    left: -2px;\n    z-index: 2; */\n}\n\n.cost_form_container_mobile #sticky_col0 {\n  /* position: sticky;\n    left: 67px;\n    z-index: 2; */\n}\n\n.cost_form_container_mobile th:last-child,\n.cost_form_container_mobile td:last-child {\n  width: 60px;\n  position: sticky;\n  right: -2px;\n  background-color: rgb(245, 241, 241);\n}\n\n.cost_form_container_mobile th,\n.cost_form_container_mobile td {\n  width: 120px;\n  font-size: 12px;\n  color: gray !important;\n}\n\n/* Attribute Form style for PC */\n.attribute_form_container thead {\n  position: sticky;\n  top: -4px;\n  z-index: 3;\n  background-color: white;\n}\n\n.attribute_form_container th:nth-child(1) {\n  width: 70px;\n  border-top: 7px solid #f5bf00;\n  position: sticky;\n  left: -2px;\n  z-index: 4;\n}\n\n.attribute_form_container th:nth-child(2) {\n  width: 250px;\n  border-top: 7px solid #f5bf00;\n  position: sticky;\n  left: 67px;\n  z-index: 4;\n}\n\n.attribute_form_container td:nth-child(1) .checkbox_btn[type=\"checkbox\"] {\n  margin-top: -4px;\n  margin-left: -20px;\n  height: 18px;\n  width: 18px;\n}\n\n.attribute_form_container\n  td:nth-child(1)\n  .checkbox_btn[type=\"checkbox\"]:checked {\n  background-color: #f5bf00 !important;\n}\n\n.attribute_form_container td:nth-child(1) {\n  position: sticky;\n  left: -2px;\n  z-index: 2;\n}\n\n.attribute_form_container #sticky_col0 {\n  position: sticky;\n  left: 67px;\n  z-index: 2;\n}\n\n.attribute_form_container th:last-child {\n  width: 60px;\n}\n\n.attribute_form_container th,\n.attribute_form_container td {\n  width: 120px;\n  font-size: 12px;\n  color: gray !important;\n}\n\n/*  Attribute form style for Mobile */\n.attribute_form_container_mobile thead {\n  position: sticky;\n  top: -4px;\n  z-index: 3;\n  background-color: white;\n}\n\n.attribute_form_container_mobile th:nth-child(1) {\n  width: 70px;\n  border-top: 7px solid #f5bf00;\n  /* position: sticky;\n    left: -2px; */\n}\n\n.attribute_form_container_mobile th:nth-child(2) {\n  width: 250px;\n  border-top: 7px solid #f5bf00;\n  /* position: sticky;\n    left: 67px; */\n}\n\n.attribute_form_container_mobile td:nth-child(1) {\n  /* position: sticky;;\n    left: -2px;\n    z-index: 2; */\n}\n\n.attribute_form_container_mobile #sticky_col0 {\n  /* position: sticky;\n    left: 67px;\n    z-index: 2; */\n}\n\n.attribute_form_container_mobile th:last-child,\n.attribute_form_container_mobile td:last-child {\n  width: 60px;\n  position: sticky;\n  right: -2px;\n  background-color: rgb(245, 241, 241);\n}\n\n.attribute_form_container_mobile th,\n.attribute_form_container_mobile td {\n  width: 120px;\n  font-size: 12px;\n  color: gray !important;\n}\n\n/* Package Form style for PC */\n.package_list_container thead {\n  position: sticky;\n  top: -4px;\n  z-index: 3;\n  background-color: white;\n}\n\n.package_list_container th:nth-child(1) {\n  width: 70px;\n  position: sticky;\n  left: -2px;\n  z-index: 4;\n}\n\n.package_list_container th:nth-child(2) {\n  width: 250px;\n  position: sticky;\n  left: 67px;\n  z-index: 4;\n}\n\n.package_list_container td:nth-child(1) .checkbox_btn[type=\"checkbox\"] {\n  margin-top: -4px;\n  margin-left: -20px;\n  height: 18px;\n  width: 18px;\n}\n\n.package_list_container td:nth-child(1) .checkbox_btn[type=\"checkbox\"]:checked {\n  background-color: #f5bf00 !important;\n}\n\n.package_list_container td:nth-child(1) {\n  position: sticky;\n  left: -2px;\n  z-index: 2;\n}\n\n.package_list_container #sticky_col0 {\n  position: sticky;\n  left: 67px;\n  z-index: 2;\n}\n\n.package_list_container th:last-child {\n  width: 60px;\n}\n\n.package_list_container th,\n.package_list_container td {\n  width: 120px;\n  font-size: 12px;\n  color: gray !important;\n}\n\n/*  Package form style for Mobile */\n.package_list_container_mobile thead {\n  position: sticky;\n  top: -4px;\n  z-index: 3;\n  background-color: white;\n}\n\n.package_list_container_mobile th:nth-child(1) {\n  width: 70px;\n  /* border-top: 7px solid #f5bf00; */\n  /* position: sticky;\n    left: -2px; */\n}\n\n.package_list_container_mobile th:nth-child(2) {\n  width: 250px;\n  /* border-top: 7px solid #f5bf00; */\n  /* position: sticky;\n    left: 67px; */\n}\n\n.package_list_container_mobile td:nth-child(1) {\n  /* position: sticky;;\n    left: -2px;\n    z-index: 2; */\n}\n\n.package_list_container_mobile #sticky_col0 {\n  /* position: sticky;\n    left: 67px;\n    z-index: 2; */\n}\n\n.package_list_container_mobile th:last-child,\n.package_list_container_mobile td:last-child {\n  width: 60px;\n  position: sticky;\n  right: -2px;\n  background-color: rgb(245, 241, 241);\n}\n\n.package_list_container_mobile th,\n.package_list_container_mobile td {\n  width: 120px;\n  font-size: 12px;\n  color: gray !important;\n}\n\n/* Group Form style for PC */\n.group_form_container thead {\n  position: sticky;\n  top: -4px;\n  z-index: 3;\n  background-color: white;\n}\n\n.group_form_container th:nth-child(1) {\n  width: 35px;\n  /* border-top: 7px solid #f5bf00; */\n  position: sticky;\n  left: -2px;\n  z-index: 4;\n}\n\n.group_form_container th:nth-child(2) {\n  width: 250px;\n  /* border-top: 7px solid #f5bf00; */\n  position: sticky;\n  left: 67px;\n  z-index: 4;\n}\n\n.group_form_container td:nth-child(1) {\n  position: sticky;\n  left: -2px;\n  z-index: 2;\n}\n\n.group_form_container #sticky_col0 {\n  position: sticky;\n  left: 67px;\n  z-index: 2;\n}\n\n.group_form_container th:last-child {\n  width: 35px !important;\n}\n\n.group_form_container th,\n.group_form_container td {\n  width: 120px;\n  font-size: 12px;\n  color: gray !important;\n}\n\n/*  Cost form style for Mobile */\n.group_form_container_mobile thead {\n  position: sticky;\n  top: -4px;\n  z-index: 3;\n  background-color: white;\n}\n\n.group_form_container_mobile th:nth-child(1) {\n  width: 70px;\n  /* border-top: 7px solid #f5bf00; */\n  /* position: sticky;\n    left: -2px; */\n}\n\n.group_form_container_mobile th:nth-child(2) {\n  width: 250px;\n  /* border-top: 7px solid #f5bf00; */\n  /* position: sticky;\n    left: 67px; */\n}\n\n.group_form_container_mobile td:nth-child(1) {\n  /* position: sticky;;\n    left: -2px;\n    z-index: 2; */\n}\n\n.group_form_container_mobile #sticky_col0 {\n  /* position: sticky;\n    left: 67px;\n    z-index: 2; */\n}\n\n.group_form_container_mobile th:last-child,\n.group_form_container_mobile td:last-child {\n  width: 60px;\n  position: sticky;\n  right: -2px;\n  background-color: rgb(245, 241, 241);\n}\n\n.group_form_container_mobile th,\n.group_form_container_mobile td {\n  width: 120px;\n  font-size: 12px;\n  color: gray !important;\n}\n\n/* Create Service */\n.create_service {\n  height: 100vh;\n  overflow-y: scroll;\n  padding-bottom: 180px;\n  width: 100%;\n}\n\n.detail_form input,\n.detail_form select {\n  border: none;\n  font-size: 14px;\n}\n\n.detail_form input:focus,\n.detail_form select:focus {\n  box-shadow: none;\n  outline: none;\n  border: none;\n}\n\n.detail_form input,\n.detail_form select {\n  border: none;\n  font-size: 14px;\n}\n\n.detail_form input:focus,\n.detail_form select:focus {\n  box-shadow: none;\n  outline: none;\n  border: none;\n}\n\n.create_form_row input {\n  border-left: none;\n  border-top: none;\n  border-right: none;\n  border-bottom: 2px solid white;\n  border-radius: 0px;\n  font-size: 14px;\n  color: gray;\n}\n\n.create_form_row input:focus {\n  box-shadow: none;\n  font-size: 14px;\n  border-bottom: 2px solid #f5bf00;\n}\n\n.create_form_row .input_wrapper input,\n.create_form_row .input_wrapper textarea {\n  border-left: none;\n  border-top: none;\n  border-right: none;\n  border-bottom: 2px solid white !important;\n  border-radius: 0px;\n  font-size: 14px;\n  color: gray;\n}\n\n.create_form_row .input_wrapper input:focus,\n.create_form_row .input_wrapper textarea:focus {\n  border-bottom: 2px solid #f5bf00 !important;\n}\n\n.add-btn {\n  margin-left: 10px;\n  border-radius: 20px;\n  background-color: transparent;\n}\n\n.addcol_btn_th {\n  text-align: center;\n  width: 40 !important;\n}\n\n.delete-btn {\n  padding: 2px 5px;\n  margin-left: 5px;\n  background-color: #f44336;\n  color: #fff;\n  border: none;\n  cursor: pointer;\n}\n\n.add-row-btn {\n  margin-top: 10px;\n}\n\n.delete-btn:disabled {\n  background-color: #ccc;\n  cursor: not-allowed;\n}\n\ntd input,\ntd select {\n  background-color: transparent;\n  border: none;\n  width: 100%;\n}\n\n.tbl_footer_main {\n  border-radius: 8px;\n  opacity: 1;\n  padding: 0;\n}\n\n.small_col {\n  width: 70px !important;\n}\n\n.gp_package_list_container #sticky_cell_top_border {\n  width: 70px !important;\n  /* border-top: 7px solid #f5bf00 !important; */\n  position: sticky !important;\n  left: 0px !important;\n}\n\n.gp_package_list_container #sticky_col1 {\n  width: 250px;\n  /* border-top: 7px solid #f5bf00 !important; */\n  position: sticky !important;\n  left: 70px !important;\n}\n\n.group_list_container #sticky_cell_top_border {\n  width: 40px;\n  position: sticky !important;\n  left: 0px !important;\n}\n\n.group_list_container #sticky_col1 {\n  width: 250px;\n  position: sticky !important;\n  left: 70px !important;\n}\n\n.price_list_container #sticky_cell_top_border {\n  width: 70px;\n  position: sticky !important;\n  left: 0px !important;\n}\n\n.price_list_container #sticky_col1 {\n  width: 250px;\n  position: sticky !important;\n  left: 70px !important;\n}\n\n.disable_area {\n  pointer-events: none;\n  background-color: rgb(251, 248, 248) !important;\n}\n\n.pricing_table thead {\n  position: sticky;\n  background-color: white;\n}\n\n.pricing_table thead th:first-child {\n  width: 70px;\n  border-top: 7px solid #f5bf00 !important;\n  position: sticky !important;\n  left: 0 !important;\n}\n\n.pricing_table thead th:nth-child(2) {\n  width: 200px;\n  border-top: 7px solid #f5bf00 !important;\n  position: sticky !important;\n  left: 70px !important;\n}\n\n.pricing_table tbody td:first-child {\n  position: sticky !important;\n  left: 0 !important;\n}\n\n.pricing_table thead {\n  z-index: 9999 !important;\n}\n\n.pricing_table tbody {\n  position: relative;\n  z-index: 999;\n}\n\n.media_menu_listing {\n  font-size: 11px;\n  color: rgb(158, 158, 158);\n}\n\n/* Responsive Style */\n.pc_display {\n  display: block !important;\n}\n\n.mobile_display {\n  display: none !important;\n}\n\n.dragging-row {\n  background-color: rgb(168, 77, 77) !important;\n  cursor: move !important;\n  color: blue !important;\n}\n\n.table {\n  width: auto;\n  table-layout: fixed;\n  border-collapse: collapse;\n  background-color: white;\n}\n\n.table th,\n.table td {\n  border: 1px solid #ccc;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n.dragging-row {\n  border: 2px dotted #f5bf00 !important;\n  background-color: transparent !important;\n  cursor: move;\n  background-color: #a48204 !important;\n  color: white !important;\n  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;\n}\n\n.dragging-row td:nth-child(1) {\n  background-color: lightgray !important;\n}\n\n.dragtr {\n  cursor: move;\n}\n\n.over {\n  border: 2px dotted #f5bf00 !important;\n  opacity: 1 !important;\n  background-color: #a48204 !important;\n}\n\n.hb {\n  background-color: black !important;\n}\n\n.css-154xyx0-MuiInputBase-root-MuiOutlinedInput-root.Mui-focused\n  .MuiOutlinedInput-notchedOutline {\n  //  border-color: #f5bf00 !important;\n  border: none;\n  //  border-width: 2px\n}\n\n.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {\n  //  border-color: #f5bf00 !important;\n  border: none;\n\n  //  border-width: 2px\n}\n\n.selected_service_list {\n  background-color: white;\n  border: 1px solid lightgray;\n  border-radius: 8px;\n  padding: 10px;\n  color: gray;\n  font-size: 90%;\n}\n\n.selected_service_list .selected_row {\n  cursor: pointer;\n  border-bottom: 1px solid lightgray;\n}\n\n.selected_service_list .selected_row:hover {\n  background-color: rgb(252, 253, 252);\n}\n\n.add_service_btn {\n  background-color: white;\n  border: 1px solid lightgray !important;\n  color: gray;\n  border-radius: 8px;\n  font-size: 80%;\n  height: 35px;\n}\n\n.add_service_btn .addbox_icon {\n  color: #f5bf00 !important;\n  height: auto !important;\n}\n\n.MuiFormLabel-root.MuiInputLabel-root.MuiInputLabel-formControl.MuiInputLabel-animated.MuiInputLabel-outlined {\n  color: gray;\n  /* Replace 'red' with your desired label color */\n}\n\n/* Contact US Form */\n.contact {\n  max-height: 100vh;\n  overflow: scroll;\n  padding-bottom: 100px;\n}\n\n.contact p {\n  font-size: 13px;\n}\n\n.contact input,\n.contact label,\n.contact textarea {\n  font-size: 12px;\n}\n\n.contact textarea {\n  border-radius: 0px !important;\n  border: none;\n}\n\n.contact textarea:focus {\n  box-shadow: none;\n}\n\n.contact_row .contact_sec1 {\n  padding-top: 50px;\n}\n\n.contact_row .contact_sec2 {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.contact_row .text_line {\n  height: 5px;\n  width: auto;\n  margin-top: -25px;\n}\n\n.contact_row .input_wrapper {\n  overflow: hidden;\n}\n\n.textarea_wrapper {\n  border: 1px solid lightgray;\n  width: 100%;\n  background-color: white;\n}\n\n.textarea_wrapper label {\n  padding-left: 10px;\n  font-size: 12px;\n  color: gray;\n  padding-bottom: 0px;\n  margin-bottom: 0px;\n}\n\n.contact_row .contact_btn {\n  width: 40%;\n  font-size: 12px;\n  background-color: #6188fe;\n}\n\n.media_links .media_gp {\n  border-radius: 12px;\n  color: white;\n  font-size: 12px;\n  background-color: #6188fe;\n}\n\n.media_links {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.media_links .icon_name {\n  font-size: 10px;\n  margin-top: 4px;\n  margin-left: 3px;\n}\n\n.list_publish_btn {\n  font-size: 10px !important;\n}\n\n/* Create category Form*/\n\n.cat_textarea_wrapper {\n  border-radius: 8px;\n  border: 1px solid lightgray;\n  width: 100%;\n  background-color: white;\n}\n\n.cat_textarea_wrapper label {\n  padding-left: 10px;\n  font-size: 12px;\n  color: gray;\n  padding-bottom: 0px;\n  margin-bottom: 0px;\n}\n\n.create_form_row textarea {\n  border: none;\n}\n\n.create_form_row textarea:focus {\n  box-shadow: none;\n}\n\n.create_category {\n  height: 85vh;\n}\n\n.create_category .fixed_btn_gp {\n  position: absolute;\n  right: 5%;\n  bottom: 5%;\n}\n\n.fixed_btn_gp .cancel_btn {\n  color: gray !important;\n  background-color: #edf0f5 !important;\n}\n\n.category_form input,\n.category_form textarea,\n.category_form select {\n  font-size: 12px !important;\n}\n\n/* Sub category Form */\n.create_scategory {\n  height: 85vh;\n}\n\n.create_scategory .fixed_btn_gp {\n  position: absolute;\n  right: 5%;\n  bottom: 5%;\n}\n\n.scategory_form input,\n.scategory_form textarea,\n.scategory_form select {\n  font-size: 12px !important;\n}\n\n.switch_input_wrapper {\n  border: 1px solid lightgray;\n  border-radius: 8px;\n  width: 100%;\n  background-color: white;\n  overflow: hidden;\n}\n\n.detail_view_img {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 75px;\n  width: 75px;\n  border-radius: 50px;\n  border: 1px solid lightgray;\n}\n\n.detail_view_img img {\n  height: 75px;\n  width: 75px;\n  border-radius: 50px;\n  border: 1px solid lightgray;\n  object-fit: cover;\n}\n\n.detail_view_img .img_upload_label {\n  position: absolute;\n  right: 0;\n  bottom: -5px;\n  padding: 2px;\n  border-radius: 50px;\n  background-color: #f5bf00;\n}\n\n.add_attrib_value {\n  background-color: azure !important;\n}\n\n.select_business {\n  // font-size: 12px;\n  color: gray !important;\n}\n\n.enable_validation {\n  border: 2px solid red !important;\n  background-color: rgb(253, 244, 246) !important;\n  border-radius: 4px;\n}\n\n//  .Mui-selected {\n//      background-color: transparent !important;\n//      color: black !important;\n//  }\n\n.items_per_page_select {\n  border: 1px solid #aeaeae;\n  padding: 3px 5px 3px 5px;\n  width: 29px;\n  -webkit-appearance: none;\n  text-align: center;\n  border-radius: 6px;\n  color: #f5bf00 !important;\n  font-size: 14px;\n}\n.items_per_page_select::-webkit-appearance {\n  display: none;\n}\n.per-page-text {\n  font-size: 16px;\n  color: #969696;\n}\n\n.items_per_page_select:focus {\n  border: none;\n  outline: none;\n}\n\n.items_per_page_select option:hover {\n  background-color: #f5bf00 !important;\n  color: white !important;\n}\n\n.column_main_wrapper {\n  max-height: 70vh;\n  overflow-y: scroll;\n}\n\n.col_btn_div {\n  height: 60px;\n  width: 300px;\n}\n\n.col_btn_div button {\n  border: 2px solid #f5bf00 !important;\n}\n\n.col_btn_div button:hover {\n  background-color: #facf35;\n  border: 2px solid #facf35 !important;\n}\n\n.list_col_container {\n  display: flex;\n  flex-direction: column;\n  overflow-y: scroll;\n  height: 95vh;\n  padding-bottom: 100px;\n}\n\n.selectedColumn {\n  background-color: #f5bf00;\n}\n\n.col_blue_btn_div {\n  height: 60px;\n  width: 300px;\n}\n\n.selectedColumnBlue {\n  background-color: #548dff;\n}\n\n.col_blue_btn_div button {\n  border: 2px solid #548dff !important;\n}\n\n.col_blue_btn_div button:hover {\n  background-color: #548dff;\n}\n\n.add_blue_btn {\n  background-color: white;\n  border: 1px solid lightgray !important;\n  color: gray;\n  border-radius: 8px;\n  font-size: 80%;\n  height: 35px;\n}\n\n.add_blue_btn .addbox_blue_icon {\n  color: #548dff !important;\n  height: auto !important;\n}\n\n.add_yellow_btn {\n  background-color: white;\n  border: 1px solid lightgray !important;\n  color: gray;\n  border-radius: 8px;\n  font-size: 80%;\n  height: 35px;\n}\n\n.add_yellow_btn .addbox_yellow_icon {\n  color: #f5bf00 !important;\n  height: auto !important;\n}\n\n.selectedColumnyellow {\n  background-color: #f5bf00;\n}\n\n.scrollable_col_list {\n  display: flex;\n  list-style: none;\n  max-width: 88vw;\n  overflow-x: scroll;\n  border: 2px dotted #f5bf00;\n  height: 40px;\n  width: 100%;\n}\n\n.scrollable_col_list::-webkit-scrollbar {\n  display: none;\n}\n\n.scrollable_div {\n  padding-left: 60px !important;\n  padding-right: 60px !important;\n}\n\n@media screen and (max-width: 576px) {\n  .pc_display {\n    display: none !important;\n  }\n\n  .mobile_display {\n    display: block !important;\n  }\n\n  .service_header_mobile p {\n    font-size: 12px;\n    margin-top: -10px;\n  }\n\n  .service_header_mobile button {\n    font-size: 12px !important;\n    padding: 2px 12px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
